module.exports = {
  __depends__: [ require(45) ],
  __init__: [ 'canvas' ],
  canvas: [ 'type', require(37) ],
  elementRegistry: [ 'type', require(39) ],
  elementFactory: [ 'type', require(38) ],
  eventBus: [ 'type', require(40) ],
  graphicsFactory: [ 'type', require(41) ]
};